var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "Please confirm",
        "ok-variant": "success",
        "hide-header-close": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: _vm.onClickApprove,
      },
    },
    [
      _c("p", [
        _vm._v("You are going to resync "),
        _c("strong", [_vm._v(_vm._s(_vm.polling))]),
        _vm._v(" for this facility"),
      ]),
      _vm._v(" "),
      _vm.license
        ? _c("strong", [
            _vm._v(
              _vm._s(`${_vm.license.facility.name} - ${_vm.license.number}`)
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Number of days to re-sync" } },
        [
          _c("b-form-input", {
            attrs: { type: "number" },
            model: {
              value: _vm.days,
              callback: function ($$v) {
                _vm.days = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "days",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }